import { graphql, useStaticQuery } from "gatsby"
import React from "react"
import { css } from "styled-components"
import Hero from "../../../components/shared/hero"

const useHeroImages = () => {
    const query = useStaticQuery(graphql`
    query {
      lg: file(
        relativePath: {
          eq: "4_COMPANY/Security/hero images/hero 1920.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 1920) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      md: file(
        relativePath: {
          eq: "4_COMPANY/Security/hero images/hero 1440.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      sm: file(
        relativePath: {
          eq: "4_COMPANY/Security/hero images/hero 360.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)

  const images = Object.keys(query).reduce((acc, current) => {
    acc[current] = query[current].childImageSharp.fluid
    return acc
  }, {})

  return images
}

const HeroOverlay = css`
  background-color: var(--naval);
  mix-blend-mode: multiply;
`

const SecurityHero = ({ title, description }) => {
    const images = useHeroImages()
  
    return (
      <Hero
        overlayStyle={HeroOverlay}
        sizes={images}
        title={title}
        description={description}
      />
    )
  }
  
  export default SecurityHero
